import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from '../dashboard/dashboard.component';
import { RegisterComponent } from '../register/register.component';
import {AuthGuardService} from '../../services/auth-guard.service'
import { GatewayComponent } from '../gateway/gateway.component';
import { ScanBarCodeComponent } from '../scan-bar-code/scan-bar-code.component';


const routes: Routes = [
  { path: '', component: DashboardComponent }
  , { path: 'dashboard/:registerId/:kioskId', component: DashboardComponent  }
  , { path: 'dashboard/:registerId', component: DashboardComponent  }
  , { path: 'dashboard', component: DashboardComponent  }
  , { path: 'register/:registerId/:kioskId', component: RegisterComponent,canActivate: [AuthGuardService]  }
  , { path: 'register/:registerId', component: RegisterComponent,canActivate: [AuthGuardService]  }
  , { path: 'register', component: RegisterComponent,canActivate: [AuthGuardService] }
  , { path: 'gateway/:registerId/:kioskId', component: GatewayComponent,canActivate: [AuthGuardService]  }
  , { path: 'gateway/:registerId', component: GatewayComponent,canActivate: [AuthGuardService]  }
  , { path: 'gateway', component: GatewayComponent,canActivate: [AuthGuardService] }
  , { path: 'scan/:registerId/:kioskId', component: ScanBarCodeComponent,canActivate: [AuthGuardService]  }
  , { path: 'scan/:registerId', component: ScanBarCodeComponent,canActivate: [AuthGuardService]  }
  , { path: 'scan', component: ScanBarCodeComponent,canActivate: [AuthGuardService] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
